
import { backendGetRequest } from "./callBackend";

export async function detokenizeAccountDetails (recipientId){
    var data = {
        accountNumber: "",
        routingNumber: "",
    }
    if(!recipientId || recipientId.length === 0) {
        return data;
    }
    var res = await backendGetRequest(
        "/api/payments/counterparty/detokenize/",
        { params: { counterparty_id: recipientId } },
        ""
        );
  
    if(res?.status === 200){
        data['accountNumber'] = res?.data?.account_number;
        data['routingNumber'] = res?.data?.routing_number;
    }
    return data;
}